<template>
  <div class="input-wrapper mb-4">
    <form class="inline-edit flex-grow-1" @submit.prevent="addSection" v-if="isEditing">
      <input
        class="add-section-input text-medium-1"
        placeholder="Enter section name ([enter] to save)"
        type="text"
        @blur="onBlur"
        @keydown.esc="resetEdit"
        v-model="title"
        v-autofocus
      />
    </form>
    <link-button class="p-0 text-medium-1 ml-2" @click="isEditing = true" v-else
      >+ New Section</link-button
    >
  </div>
</template>

<script>
import LinkButton from '@/components/buttons/LinkButton.vue'
import showAPIError from '@/utils/showAPIError'
import { mapActions } from 'vuex'

export default {
  name: 'AddSection',
  props: ['orgId', 'projectId'],
  components: { LinkButton },
  data() {
    return {
      title: '',
      isEditing: false,
      isSubmitting: false
    }
  },
  computed: {},
  methods: {
    ...mapActions('project', ['createSection']),
    onBlur() {
      if (!this.title) {
        this.isEditing = false
      } else {
        this.addSection()
      }
    },
    resetEdit() {
      this.isEditing = false
      this.title = ''
    },
    async addSection() {
      if (this.isSubmitting) return
      try {
        this.isSubmitting = true
        const section = await this.createSection({
          orgId: this.orgId,
          payload: {
            title: this.title,
            projectId: this.projectId
          }
        })
        this.$emit('added', section)
        this.resetEdit()
      } catch (e) {
        showAPIError(e)
      }
      this.isSubmitting = false
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/components/_input.scss';

.add-section-input {
  padding: 4px 8px;
  width: 270px;
  margin-bottom: 20px;
}
.input-wrapper {
  padding-left: 52px;
  position: sticky;
  left: 0;
}
</style>
